import { storage } from '../../helpers/storage';

export default storage.get('user', {
  authenticted: false,
});
